import { render, staticRenderFns } from "./ZjzqrView.vue?vue&type=template&id=1015356c&scoped=true"
import script from "./ZjzqrView.vue?vue&type=script&lang=js"
export * from "./ZjzqrView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1015356c",
  null
  
)

export default component.exports